module.exports = __webpack_public_path__ + "media/images/pic/certificates/gazele-2010-3125180c76446ca07e4ec733377c2dcf.png";